import { Link } from "react-router-dom";
import { formatPublicationDate, getReadTime } from "@/content/researchArticles";
import { getPublicationImage, getPublicationImageAlt } from "@/content/publications";
import { CompactPhotographCredit, responsivePhotographProps } from "@/components/LicensedPhotograph";
import "./HomeEditorial.css";

export const FeaturedResearch = ({ article }) => {
  const atAGlance = Object.fromEntries(article.frontMatter.atAGlance.rows);
  return <section className="home-featured shell" aria-labelledby="featured-research-title" data-testid="featured-research-section">
  <header className="home-featured-heading" data-testid="featured-research-header">
    <p className="section-index" data-testid="featured-research-index">01</p>
    <p className="eyebrow" data-testid="featured-research-label">Featured Research</p>
  </header>
  <div className="home-featured-layout">
    <div className="home-featured-panel home-featured-copy" data-testid="featured-research-panel">
      <p className="home-featured-category" data-testid="featured-research-category">{article.category}</p>
      <h2 id="featured-research-title" data-testid="featured-research-title"><Link to={article.path} data-testid="featured-research-title-link">{article.title}</Link></h2>
      <div className="home-featured-footer">
        <p data-testid="featured-research-reading-info">{formatPublicationDate(article.publishedAt)} · {getReadTime(article)}</p>
        <Link to={article.path} data-testid="featured-research-link">Read the Research <span aria-hidden="true">→</span></Link>
      </div>
    </div>
    <figure className="home-featured-media" data-testid="featured-research-image-container">
      <Link className="home-featured-image-link" to={article.path} data-testid="featured-research-image-link">
        <img src={getPublicationImage(article)} alt={getPublicationImageAlt(article)} {...responsivePhotographProps(article.hero, "(max-width: 767px) calc(100vw - 40px), (max-width: 1328px) 50vw, 580px")} style={{ objectPosition: article.hero.position }} loading="eager" fetchPriority="high" data-testid="featured-research-image" />
      </Link>
      <figcaption data-testid="featured-research-attribution">
        <span>Research image</span>
        <CompactPhotographCredit article={article} testId="featured-research-photo-credit" />
      </figcaption>
    </figure>
  </div>
  <div className="home-featured-insights">
    <div data-testid="featured-research-question"><span>The Question</span><p data-testid="featured-research-question-text">{atAGlance["Strategic Question"]}</p></div>
    <div data-testid="featured-research-view"><span>FU View</span><p data-testid="featured-research-view-text">{atAGlance["FU View"]}</p></div>
  </div>
</section>;
};

export const FounderNote = () => <section className="section-block home-founder shell" aria-labelledby="home-founder-heading" data-testid="home-founder-section">
  <div className="home-founder-heading">
    <p className="section-index" data-testid="home-founder-index">04</p>
    <h2 className="eyebrow" id="home-founder-heading" data-testid="home-founder-heading">From the Founder</h2>
  </div>
  <div className="home-founder-copy">
    <blockquote data-testid="home-founder-statement">FU Research began with a simple question: why do some businesses preserve their competitive advantage while others weaken it through growth? FU Research focuses on examining those choices through evidence and turning the findings into practical strategy.</blockquote>
    <div className="home-founder-signoff">
      <div><p data-testid="home-founder-name">Ruilin Fu</p><span data-testid="home-founder-role">Founder, FU Research</span></div>
      <Link className="text-link" to="/about" data-testid="home-founder-about-link">About FU Research <span aria-hidden="true">→</span></Link>
    </div>
  </div>
</section>;
